import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toggleTableView } from '../../../store/Admin/reports/reports.slice'
import './header.css'
import logo from '../../../assets/Admin/logo.svg'
import profile from '../../../assets/Admin/temp-profile.jpg'
import RouteNames from '../../../utils/Admin/constants/route-names.constants'
import { resetAllReduxState } from '../../../store/Admin/authentication/authentication.actions'

export const Header = (props) => {

  const location = useLocation();
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showDropdown, setShowDropdown] = useState(false)
  
  useEffect(() => {
    window.onpopstate = () => {
      dispatch(toggleTableView(false))
    }
    if (!location.pathname.match('/reports/')) {
      dispatch(toggleTableView(false))
    }
  }, [location])
  

  const handleDropdownClick = (type) => {
    setShowDropdown(false)
    if (type === 'logout') {
      sessionStorage.clear()
      dispatch(resetAllReduxState())
      navigate('login')
    }
  }

  return (
    <nav className='header-nav-section bg-white px-1 px-xl-5'>
      <div className="d-flex align-items-center justify-content-between header-nav-top-section px-lg-4 py-3">
        <img src={logo} alt="K-Fintech logo" />
        <div className="d-flex align-items-center">
          <ul className="nav-bottom-section-links d-flex align-items-center mb-0">
            {
              RouteNames.map(item => (
                <Link key={item.id} to={item.route} className={location.pathname === item.route ? 'text-capitalize me-4 ms-2 cursor-pointer header-nav-link-active cl-custom-blue no-link-dec' : 'header-nav-link text-capitalize me-4 ms-2 cursor-pointer cl-custom-grey no-link-dec'}>{ item.name }</Link>
              ))
            }
          </ul>
          <div className="nav-profile-container ms-2 position-relative">
            <img onClick={() => setShowDropdown(!showDropdown)} width="40" height="40" className='rounded-circle cursor-pointer' src={profile} alt="profile avatar" />
            <ul className={showDropdown ? "profile-dropdown position-absolute p-0 no-list-style" : "d-none"}>
              {/* <li onClick={() => handleDropdownClick('profile')} className='py-2 px-3 fs-sm cl-custom-grey text-capitalize cursor-pointer'>profile</li>
              <li onClick={() => handleDropdownClick('settings')} className='py-2 px-3 fs-sm cl-custom-grey text-capitalize cursor-pointer'>settings</li> */}
              <li onClick={() => handleDropdownClick('logout')} className='py-2 px-3 fs-sm cl-custom-grey text-capitalize cursor-pointer'>logout</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="px-lg-4 py-lg-3 header-nav-bottom-section d-flex align-items-center justify-content-between">
        <div hidden={!tableView} className="vendor-label">{ selectedVendor }</div>
        <div hidden={tableView}></div>
        <ul className="nav-bottom-section-links d-flex align-items-center mb-0">
          <button hidden={!tableView} className='nav-download-btn text-white text-capitalize me-4 py-1 px-3'>download</button>
          <Link to="/reports" className='text-capitalize text-white me-4 cursor-pointer'>MIS reports</Link>
          <Link to="/upload" className='text-capitalize text-white cursor-pointer'>upload MIS</Link>
        </ul>
      </div> */}
    </nav>
  )
}
